import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const getStudentParcours = async (idStudent, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/parcours/studentParcours/${idStudent}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const getAllParcours = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/parcours/allParcours`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};
